/**
 * Title Insurance Types
 */
export const TITLE_INSURANCE_PAID_BY_BUYER = 'Buyer'
export const TITLE_INSURANCE_PAID_BY_SELLER = 'Seller'
export const TITLE_INSURANCE_NOT_OFFERED = 'Not Available'
export const TITLE_INSURANCE_REFER_TO_PSA = 'Refer to Purchase Agreement'

/**
 * Deed Type constants
 */
const WARRANTY_DEED = 'Warranty Deed'
export const SPECIAL_WARRANTY_DEED = 'Special Warranty Deed'
export const QUIT_CLAIM_DEED = 'Quitclaim Deed'
const QUIT_CLAM_AND_ASSIGN_OF_INTEREST_IN_SHERIFF =
  "Quitclaim Deed and Assignment of Interest in Sheriff's Deed"
const QUIT_CLAM_AND_ASSIGN_OF_SHERIFF_CERT =
  "Quitclaim Deed and Assignment of Sheriff's Certificate of Title"
const TRUSTEE_DEED = "Trustee's Deed"
const RELEASE_DEED = 'Release Deed'

/**
 * Seller Deed Types / Conveyance Docs
 */
export const SELLER_DEED_CONVERSION_MAP = {
  'Warranty Deed or equivalent': WARRANTY_DEED,
  'Special Warranty Deed or equivalent': SPECIAL_WARRANTY_DEED,
  'Quitclaim Deed or equivalent': QUIT_CLAIM_DEED,
  "Quitclaim Deed and Assignment of Interest in Sheriff's Deed":
    QUIT_CLAM_AND_ASSIGN_OF_INTEREST_IN_SHERIFF,
  "Quitclaim Deed and Assignment of Sheriff's Cert":
    QUIT_CLAM_AND_ASSIGN_OF_SHERIFF_CERT,
  "Trustee's Deed": TRUSTEE_DEED,
  'Release Deed or Equivalent': RELEASE_DEED,
}

/**
 * Seller Deed Types tooltips
 */
export const SELLER_DEED_TOOLTIP_CONVERSION_MAP = {
  [WARRANTY_DEED]:
    'A General Warranty Deed offers the maximum amount of protection.',
  [SPECIAL_WARRANTY_DEED]:
    'You will have the option to buy title insurance and receive a Special Warranty Deed.',
  [QUIT_CLAIM_DEED]:
    'A Quitclaim Deed provides no warranties or covenants to the buyer. Recommended for seasoned investors.',
  [QUIT_CLAM_AND_ASSIGN_OF_INTEREST_IN_SHERIFF]:
    "The Seller is assigning their interest in a Sheriff's Deed. A Quitclaim Deed provides no warranties or covenants to the buyer.",
  [QUIT_CLAM_AND_ASSIGN_OF_SHERIFF_CERT]:
    "The Seller is assigning their interest in a Sheriff's Certificate. A Quitclaim Deed provides no warranties or covenants to the buyer.",
  [TRUSTEE_DEED]: 'This deed will be issued by a trustee in a bankruptcy case.',
}

/**
 * Asset & Event labels
 */
export const ASSET_TYPE_LABELS = {
  rentals: 'Rental',
  mtl: 'Rental',
  'short sale': 'Short Sale',
  'private seller institutional': 'Private Seller - Institutional',
  default: 'Bank Owned',
}

export const EVENT_TYPE_LABELS = {
  online: 'Online Event',
  live: 'Live Event',
}

/**
 * Asset Types
 */
export const PRODUCT_ASSET_TYPE_BANK = 'bank'
export const PRODUCT_ASSET_TYPE_SHORT_SALE = 'short-sale'
export const PRODUCT_ASSET_TYPE_RENTAL = 'rentals'
export const PRODUCT_ASSET_TYPE_TPS = 'tps'
export const PRODUCT_ASSET_TYPE_TPS_ONLINE = 'tps-online'
export const PRODUCT_ASSET_TYPE_TPS_LIVE = 'tps-live'
export const PRODUCT_ASSET_TYPE_PRIVATE_SELLER_INSTITUTIONAL =
  'private-seller-institutional'
export const TITLE_INSURANCE_TOOLTIP =
  "If you choose the Seller's closing company, the Seller will pay for title insurance. If you choose your own closing company, you are responsible for obtaining title insurance."

export const AUCTION_DAY_STATUSES = {
  REMOVED_FROM_AUCTION: '1',
  AUCTION_PENDING: '2',
  RE_AUCTION_PENDING_FELL_OUT: '3',
  SOLD: '4',
  DID_NOT_SELL: '6',
  FINANCE_IN_PROGRESS: '7',
  ESCROW_IN_PROGRESS: '14',
  CONTRACT_COMPLETE: '18',
  RE_AUCTION_PENDING_DID_NOT_SELL: '20',
}
